import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseQueryConfig } from "../api";
import { getToken } from "../models/users.models";
import { IMedia } from "../models/video.models";

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

const homeConfig = {
  ...baseQueryConfig,
  baseUrl: baseQueryConfig.baseUrl + "/home",
  prepareHeaders: async (headers: Headers) => {
    let session = getToken();
    if (!session || !session.token) {
      await delay(500);
      session = getToken();
    }

    if (session && session.token) {
      headers.set("Authorization", `Bearer ${session.token}`);
    }

    return headers;
  },
};

export const homeApi = createApi({
  reducerPath: "home",
  tagTypes: ["Home"],
  baseQuery: fetchBaseQuery(homeConfig),
  endpoints: (builder) => ({
    getUploadMedia: builder.query<any, { jobUid: number }>({
      query: ({ jobUid }) => ({
        url: `/upload-media/csv/${jobUid}`,
      }),
      providesTags: ["Home"],
    }),
    uploadMedia: builder.mutation<void, FormData>({
      query: (data) => ({
        url: "/upload-media/csv",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Home"],
    }),
    uploadVideo: builder.mutation<{ id: number; data: IMedia }, FormData>({
      query: (formData) => ({
        url: "/video-upload",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Home"],
    }),
    uploadAudio: builder.mutation<{ id: number; data: IMedia }, FormData>({
      query: (formData) => ({
        url: "/music-upload",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Home"],
    }),
  }),
});

export const {
  useUploadMediaMutation,
  useGetUploadMediaQuery,
  useUploadAudioMutation,
  useUploadVideoMutation,
} = homeApi;

